import { isExperimentEnabled } from '@confluence/feature-experiments';

export function getHasAudioButton({
	isAIEnabledForContent,
	isAIEarlyAccessEnabled,
}: {
	isAIEnabledForContent: boolean;
	isAIEarlyAccessEnabled: boolean;
}): boolean {
	return (
		isAIEnabledForContent &&
		isAIEarlyAccessEnabled &&
		(!isExperimentEnabled('confluence_audio_v3') ||
			!isExperimentEnabled('confluence_ai_consumption_byline'))
	);
}
